import React from 'react';
export var WarningStatusIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16", width: "16", height: "16" },
    React.createElement("polygon", { fill: "#f2c973", points: "15 15 1 15 8 1 15 15" }),
    React.createElement("polygon", { fill: "#444", points: "8.75 11 7.25 11 7 5 9 5 8.75 11" }),
    React.createElement("circle", { fill: "#444", cx: "8", cy: "13", r: "1" }))); };
//# sourceMappingURL=WarningStatusIcon.js.map